import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const TrendCharts = ({ orders }) => {
  // Préparer les données pour les graphiques
  const prepareChartData = () => {
    const last30Days = [...Array(30)].map((_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - i);
      return d;
    }).reverse();

    const dailyOrders = last30Days.map(date => {
      const dayStart = new Date(date);
      dayStart.setHours(0, 0, 0, 0);
      const dayEnd = new Date(date);
      dayEnd.setHours(23, 59, 59, 999);

      return orders.filter(order => {
        const orderDate = order.createdAt?.seconds 
          ? new Date(order.createdAt.seconds * 1000) 
          : new Date(order.createdAt);
        return orderDate >= dayStart && orderDate <= dayEnd;
      }).length;
    });

    const dailyRevenue = last30Days.map(date => {
      const dayStart = new Date(date);
      dayStart.setHours(0, 0, 0, 0);
      const dayEnd = new Date(date);
      dayEnd.setHours(23, 59, 59, 999);

      return orders
        .filter(order => {
          const orderDate = order.createdAt?.seconds 
            ? new Date(order.createdAt.seconds * 1000) 
            : new Date(order.createdAt);
          return orderDate >= dayStart && orderDate <= dayEnd;
        })
        .reduce((sum, order) => sum + (order.totalPrice || 0), 0);
    });

    const labels = last30Days.map(date => 
      date.toLocaleDateString('fr-DZ', { day: 'numeric', month: 'short' })
    );

    return {
      labels,
      dailyOrders,
      dailyRevenue
    };
  };

  const { labels, dailyOrders, dailyRevenue } = prepareChartData();

  const ordersData = {
    labels,
    datasets: [
      {
        label: 'Nombre de commandes',
        data: dailyOrders,
        fill: true,
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        tension: 0.4
      }
    ]
  };

  const revenueData = {
    labels,
    datasets: [
      {
        label: 'Chiffre d\'affaires (DA)',
        data: dailyRevenue,
        backgroundColor: 'rgb(16, 185, 129)',
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            if (context.dataset.label === 'Chiffre d\'affaires (DA)') {
              return `${context.dataset.label}: ${context.parsed.y.toLocaleString('fr-DZ')} DA`;
            }
            return `${context.dataset.label}: ${context.parsed.y}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            if (revenueData.datasets[0].label === 'Chiffre d\'affaires (DA)') {
              return `${value.toLocaleString('fr-DZ')} DA`;
            }
            return value;
          }
        }
      }
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Tendance des commandes</h3>
        <Line data={ordersData} options={options} />
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Chiffre d'affaires quotidien</h3>
        <Bar data={revenueData} options={options} />
      </div>
    </div>
  );
};

export default TrendCharts;
